import { compose, mapProps, setDisplayName } from 'recompose';

import StylingToCSSTextfieldInner from './StylingToCSSTextfieldInner';
import StylingToCSSTextfieldOuter from './StylingToCSSTextfieldOuter';

export default compose(
  StylingToCSSTextfieldInner,
  StylingToCSSTextfieldOuter,
  setDisplayName('StylingToCSSTextfield'),
  mapProps(({ styleTextfieldInner, styleTextfieldOuter, ...props }) => ({
    ...props,
    styleTextfield: { ...styleTextfieldInner, ...styleTextfieldOuter },
  })),
);
